import { useAccountStore } from '../stores/accountStore';

function timeAgo(isoString: string): string {
  const seconds = Math.floor((Date.now() - new Date(isoString).getTime()) / 1000);
  if (seconds < 5) return 'just now';
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  return `${Math.floor(seconds / 3600)}h ago`;
}

function truncateTicker(ticker: string): string {
  if (ticker.length <= 20) return ticker;
  const parts = ticker.split('-');
  if (parts.length >= 2) {
    const tail = parts.slice(-2).join('-');
    return `...${tail}`;
  }
  return `...${ticker.slice(-16)}`;
}

export function ActivityTicker() {
  const fills = useAccountStore((s) => s.activityTicker);
  const status = useAccountStore((s) => s.status);

  if (status !== 'connected') return null;
  if (fills.length === 0) {
    return (
      <div className="text-muted-foreground px-3 py-2 text-xs">
        No recent fills
      </div>
    );
  }

  return (
    <div className="space-y-0.5">
      {fills.map((fill) => (
        <div
          key={fill.fillId}
          className="hover:bg-muted/50 flex items-center justify-between gap-2 rounded px-2 py-1 text-xs"
        >
          <div className="flex items-center gap-2">
            <span className={fill.action === 'buy' ? 'font-medium text-green-400' : 'font-medium text-red-400'}>
              {fill.action.toUpperCase()}
            </span>
            <span className="text-muted-foreground">{fill.count}</span>
            <span className={fill.side === 'yes' ? 'text-blue-400' : 'text-orange-400'}>
              {fill.side.toUpperCase()}
            </span>
            <span className="text-muted-foreground font-mono">{truncateTicker(fill.ticker)}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-foreground">@ {fill.price}¢</span>
            <span className="text-muted-foreground/60">{timeAgo(fill.createdAt)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
